<template>
  <div class="saveSelfPoster">
    <div class="saveSelfPoster-main">
      <div class="saveSelfPoster-content">
        <img :src="posterUrl" alt="海报图片"
          @touchstart="touchStart"
          @touchmove="clearTimer"
          @touchend="clearTimer"
        >
      </div>
    </div>
    <div class="saveSelfPoster-text">
      <div class="saveSelfPoster-btn-left" @click="next">换一条</div>
      <div class="saveSelfPoster-shareText">{{shareWords[idx]}}</div>
      <div class="saveSelfPoster-btn-right" @click="copyInviteMsg">
        <img src="../assets/images/v4.1/copy-share-word.png" alt="复制">
      </div>
    </div>
    <imgShare
      :imgUrl="posterUrl"
      @shareClick="handleShareClick"
      @appShareBack="handleAppShareBack"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Clipboard from '../utils/clipBoard'
import imgShare from '@/inviteAutumn/components/ImgShare'

export default {
  name: 'saveSelfPoster',
  components: { imgShare },
  computed: mapState(['shareWords']),
  data () {
    return {
      idx: 0,
      posterUrl: '', // 合成的海报图片地址
      inviteMsg: '最近孩子一直在学而思网校上课，课上有名师教分析思维，课前课后有辅导老师贴心指导，孩子喜欢我也就放心了。强力安利给大家！扫码立减100。'
    }
  },
  created () {
    this.$xesLogger.clickMsg({
      params: {
        elementname: '海报分享',
        element_action: 'pv',
        element_value: '海报分享页面访问'
      }
    })
    this.idx = Number(this.$route.query.idx) || 0
    this.posterUrl = sessionStorage.getItem('posterImgUrl') || ''
  },
  methods: {
    next () {
      this.$xesLogger.clickMsg({
        params: {
          elementname: '海报分享',
          element_action: 'click',
          element_value: '“换一条”按钮点击'
        }
      })
      const { idx } = this
      this.idx = idx + 1
      if (this.idx >= this.shareWords.length) {
        this.idx = 0
      }
    },
    /**
     * 右上角 一键复制邀请语
     */
    copyInviteMsg () {
      this.$xesLogger.clickMsg({
        params: {
          elementname: '海报分享',
          element_action: 'click',
          element_value: '”复制分享语“按钮-点击',
          share_words: this.shareWords[this.idx]
        }
      })
      const copyResult = Clipboard.copy(this.shareWords[this.idx])
      const messageTips = copyResult ? '复制成功，快去邀请好友吧！' : '当前环境不支持，请通过海报分享'
      return this.$toast(messageTips)
    },
    /**
     * 海报长按判断
     */
    touchStart () {
      this.isLongPress = false
      this.timer = setTimeout(() => {
        this.isLongPress = true
        this.$xesLogger.clickMsg({ params: { action: 'longPress', clickid: '5.3.18', posterId: this.$route.query.posterId } })
      }, 600)
    },
    clearTimer () {
      // 清除定时器
      clearTimeout(this.timer)
      this.timer = null
    },
    /**
     * 分享按钮点击（shareFixed 回传）。
     */
    handleShareClick (scence) {
      // app分享图标被点击事件，记录点击触发日志
      let message = '其它'
      if (scence === '1') {
        message = '“微信好友”分享图标-点击'
      } else if (scence === '2') {
        message = '“朋友圈”分享图标-点击'
      }
      this.$xesLogger.clickMsg({
        params: {
          elementname: '海报分享',
          element_action: 'click',
          element_value: message,
          posterId: this.$route.query.posterId,
          posterType: this.$route.query.posterType,
          firstPosterId: this.$route.query.firstPosterId
        }
      })
    },
    /**
     * 分享结果回调
     */
    handleAppShareBack (data) {
      // 分享的结果回调方法， 1 成功，2 失败，3 取消
      console.log(data)
      this.$xesLogger.clickMsg({
        params: {
          elementname: '海报分享',
          element_action: 'click',
          element_value: '个性化海报分享结果回调'
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.saveSelfPoster {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100vh;

  &-text {
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 100%;
    height: 80px;
    margin-bottom: 20px;
    background: #efba79;

    .saveSelfPoster-btn-left {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 22px;
      height: 50px;
      padding: 4px;
      margin: 0 15px 0 20px;
      font-size: 12px;
      line-height: 15px;
      color: #fff;
      border: 1px solid white;
      border-radius: 5px;
    }

    .saveSelfPoster-shareText {
      display: -webkit-box;
      width: 250px;
      height: 42px;
      overflow: hidden;
      font-size: 12px;
      line-height: 15px;
      text-align: left;
      color: #fff;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
    }

    .saveSelfPoster-btn-right {
      width: 48px;
      height: 48px;
      margin-right: 10px;
      font-size: 12px;
      line-height: 25px;
      color: #e02727;
      // background: #fff7e4;
      border-radius: 11px;

      img {
        width: auto;
        max-width: 100%;
        height: auto;
        max-height: 100%;
      }
    }
  }

  .saveSelfPoster-main {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex: 1;
    width: 100%;

    .saveSelfPoster-content {
      width: 240px;
      height: 416px;

      img {
        // border-radius: 8px;
        box-shadow: 0 11px 21px 0 rgba(166, 160, 127, 0.47);
      }
    }
  }
}
</style>
